export function decodePcm16Base64ToFloat32(base64: string) {
  const binary = atob(base64);
  const length = binary.length / 2;
  const output = new Float32Array(length);
  for (let i = 0; i < length; i += 1) {
    const lo = binary.charCodeAt(i * 2);
    const hi = binary.charCodeAt(i * 2 + 1);
    let sample = (hi << 8) | lo;
    if (sample & 0x8000) {
      sample = sample - 0x10000;
    }
    output[i] = Math.max(-1, Math.min(1, sample / 32768));
  }
  return output;
}

export function encodeFloat32ToPcm16Base64(input: Float32Array) {
  const buffer = new Uint8Array(input.length * 2);
  for (let i = 0; i < input.length; i += 1) {
    const clamped = Math.max(-1, Math.min(1, input[i]));
    let sample = Math.round(clamped * 32767);
    if (sample < 0) {
      sample += 0x10000;
    }
    buffer[i * 2] = sample & 0xff;
    buffer[i * 2 + 1] = (sample >> 8) & 0xff;
  }
  let binary = "";
  for (let i = 0; i < buffer.length; i += 1) {
    binary += String.fromCharCode(buffer[i]);
  }
  return btoa(binary);
}
